export default __webpack_public_path__ + "static/media/happy.be40293f.svg";